import type { PropsWithChildren } from 'react';

import { useControllableState } from '@/hook';

import { VStack } from '../VStack';
import { BASE_ORIENTATION } from '../constant';
import { TAB_ITEM_SIZE, TAB_ITEM_VARIANT } from './constant';
import VTabContext from './context';
import style from './style';
import type { VTabProps } from './type';

export const VTab = ({
  children,
  className,
  defaultValue,
  orientation = BASE_ORIENTATION.HORIZONTAL,
  size = TAB_ITEM_SIZE.MD,
  value,
  variant = TAB_ITEM_VARIANT.PRIMARY,
  onValueChange,
}: PropsWithChildren<VTabProps>) => {
  const [_value, _setValue] = useControllableState({
    prop: value,
    defaultProp: defaultValue,
    onChange: onValueChange,
  });
  const twStyle = style({
    orientation: orientation ?? BASE_ORIENTATION.HORIZONTAL,
    size: size ?? TAB_ITEM_SIZE.MD,
    variant: variant ?? TAB_ITEM_VARIANT.PRIMARY,
  });

  return (
    <VTabContext.Provider
      value={{
        orientation,
        size,
        twStyle,
        variant,
        value: _value,
        setValue: _setValue,
      }}
    >
      <VStack className={className}>{children}</VStack>
    </VTabContext.Provider>
  );
};

VTab.displayName = 'VTab';
